export const PORTFOLIO_LOAD = 'PORTFOLIO_LOAD'
export const PORTFOLIO_SUCCESS = 'PORTFOLIO_SUCCESS'
export const PORTFOLIO_FAILURE = 'PORTFOLIO_FAILURE'

export const TABLE_INIT = 'TABLE_INIT'

export const PORTFOLIO_INVESTMENTS_SUCCESS = 'PORTFOLIO_INVESTMENTS_SUCCESS'
export const PORTFOLIO_DEPOSITING_SUCCESS = 'PORTFOLIO_DEPOSITING_SUCCESS'

export const OPERATIONS_SUCCESS = 'OPERATIONS_SUCCESS'